'use client';

import PageSection from 'components/PageSection/PageSection';
import { PageSectionProps } from './types';
import { usePage } from 'contexts/PageProvider';

/**
 * Wraps the PageSection component as a client component.
 *
 * Forwards the page's resolved visual settings (read from context) so that
 * modules rendered by PageSection's own ModuleCollectionRenderer — the
 * no-pre-rendered-children fallback used on the Ninetailed client / live-preview
 * path — still receive page-level props like footer color. Without this a module
 * such as CanvasNav would fall back to the default colorway in preview.
 *
 * @param props - The props to render the PageSection with
 * @returns The rendered component
 */
const ClientPageSection = (props: PageSectionProps) => {
  const { visualSettings } = usePage();
  return <PageSection {...props} visualSettings={visualSettings} />;
};

export default ClientPageSection;
